import { styled } from '@linaria/react';

export const Textarea = styled.textarea`
	width: 100%;

	border: 1px solid var(--color-grey-19-solid);

	border-radius: var(--radius-xs);
	backdrop-filter: blur(25px);

	background: var(--color-grey-7-solid);

	color: var(--color-grey-95-solid);
	font-size: var(--font-size-l);
	line-height: var(--line-height-text-m);
	padding-block: 1.2rem;
	padding-inline: 1.6rem 1rem;

	resize: none;

	transition: border-color 0.3s;

	&::placeholder {
		color: var(--color-grey-68-solid);
	}

	&:focus {
		border-color: var(--color-grey-95-solid);
		background: var(--color-grey-7-solid);
	}

	&[disabled] {
		background: var(--color-grey-10-solid);
		pointer-events: none;
		&::placeholder {
			color: var(--color-grey-52-solid);
		}
	}
`;
